var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-PilerUppNer';
                    var viewUrl = 'gfx/sprite.svg#view-icon-PilerUppNer';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 7 13',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };